import Icon from "@/components/Icon/Icon";
import { HStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { TableCell, TableRow } from "@/components/ui/table";
import { useFormatDate } from "@/hooks/date";
import { cn } from "@/lib/cn";
import type { ColumnIndexer } from "./types";

interface DateGroupHeaderCellProps {
  date: string;
  categories: unknown; // 使用しないが型互換性のために残す
  expandedGroups: Record<string, boolean>;
  toggleGroupExpansion: (date: string) => void;
  hoveredColIndex: number | null;
  handleCellMouseEnter: (rowIndex: number, colIndex: number) => void;
  handleCellMouseLeave: () => void;
  columnIndexer: ColumnIndexer;
}

export const DateGroupHeaderCell = ({
  date,
  expandedGroups,
  toggleGroupExpansion,
  hoveredColIndex,
  handleCellMouseEnter,
  handleCellMouseLeave,
  columnIndexer,
}: DateGroupHeaderCellProps) => {
  const formatDate = useFormatDate();

  // 総カラム数を取得
  const totalColumns = columnIndexer.getTotalColumnCount();

  return (
    <TableRow className="cursor-pointer bg-white hover:bg-neutral-gray-light-3">
      {/* 日付部分のセル（固定列の最初のセル） */}
      <TableCell
        className="p-2 border-t border-neutral-border sticky left-0 z-10 bg-white shadow-md"
        onClick={() => toggleGroupExpansion(date)}
      >
        <HStack className="items-center gap-1">
          <Text
            variant="buttonLabelSmall"
            className="text-neutral-muted-on-fill"
          >
            {formatDate(date, { preset: "date" })}
          </Text>
          {expandedGroups[date] ? (
            <Icon
              iconName="ChevronDownIcon"
              colorVariant="primaryOnNeutralMuted"
            />
          ) : (
            <Icon
              iconName="ChevronRight"
              colorVariant="primaryOnNeutralMuted"
            />
          )}
        </HStack>
      </TableCell>

      {/* Progress用のセル（固定列の2番目のセル） */}
      <TableCell
        className="border-t border-r border-neutral-border bg-white sticky left-32 z-10"
        onClick={() => toggleGroupExpansion(date)}
      />

      {/* 残りのカラムを埋めるためのセル */}
      {Array.from({
        length: totalColumns - columnIndexer.fixedColumnCount,
      }).map((_, index) => {
        const colIndex = index + columnIndexer.fixedColumnCount;
        return (
          <TableCell
            key={`filler-${date}-${index}`}
            className={cn(
              "border-t border-neutral-border",
              hoveredColIndex === colIndex
                ? "bg-neutral-gray-light-3"
                : "bg-white",
            )}
            onClick={() => toggleGroupExpansion(date)}
            onMouseEnter={() => handleCellMouseEnter(-1, colIndex)}
            onMouseLeave={handleCellMouseLeave}
          />
        );
      })}
    </TableRow>
  );
};
